import { Spinner } from '@/components/Spinner';
import { useCustomerPointSettingDetail } from '../../points-configuration/customerTable/hooks/useCustomerPointSettingDetail';
import { ManagePointCategoryView } from './ManagePointCategoryView';

const userTypeOptions = [{ id: 'u1', label: 'Customer', value: 'c' }];
const categoryTypeOptions = [{ id: 'c1', label: 'Default', value: 'd' }];
export const ManagePointCategoryContainer = ({
  programId,
  categoryId,
  programCode,
}: {
  programId?: string;
  categoryId?: string;
  programCode?: string;
}) => {
  const { pointSetting, isLoading } = useCustomerPointSettingDetail(programId ?? '', !!programId);
  const activeProgramCode = programCode ?? pointSetting?.programCode;
  const isReview = (activeProgramCode ?? '').toUpperCase().includes('REVIEW');

  const defaultValues = {
    userType: 'c',
    categoryType: 'd',
    categoryName: pointSetting?.category ?? '',
    description: pointSetting?.description ?? '',
    reviewRewardPoint: pointSetting?.rewardPoint ? String(pointSetting.rewardPoint) : '',
  };
  return isLoading ? (
    <Spinner />
  ) : (
    <ManagePointCategoryView
      defaultValues={defaultValues}
      userTypeOptions={userTypeOptions}
      categoryTypeOptions={categoryTypeOptions}
      categoryId={categoryId ?? ''}
      isReview={isReview}
      programCode={activeProgramCode}
      existingDescription={pointSetting?.description}
    />
  );
};
